import { takeEvery } from "redux-saga/effects";
import {
  CREATE_ACCOUNT,
  LOGIN,
  EDIT_ACCOUNT,
  GET_ACCOUNT_BY_ACCOUNT_ID,
  REQUEST_PASSWORD_RESET,
  FETCH_AUTHORIZED_EVENT,
  FETCH_USER_PURCHASES,
  FETCH_ORDER_DETAILS,
  VERIFY_ACCOUNT_TOKEN,
  RESET_ACCOUNT_PASSWORD,
  POST_CONSUME_EVENT,
  LOGIN_SSO
} from "../../state/user/constants";
import loginAccount from "./login";
import createAccount from "./createAccount";
import editAccount from "./editAccount";
import getAccountByAccountId from "./getAccountByAccountId";
import requestPasswordReset from "./requestPasswordReset";
import fetchAuthorizedEvent from "./fetchAuthorizedEvent";
import fetchUserPurchases from "./fetchUserPurchases";
import fetchOrderDetails from "./fetchOrderDetails";
import verifyUserToken from "./verifyUserToken";
import resetAccountPassword from "./resetAccountPassword";
import postConsumeEvent from "./postConsumeEvent";
import loginSso from "./loginSso";

// Watcher Saga that listens for specific action types
function* user() {
  yield takeEvery(LOGIN, loginAccount);
  yield takeEvery(CREATE_ACCOUNT, createAccount);
  yield takeEvery(EDIT_ACCOUNT, editAccount);
  yield takeEvery(GET_ACCOUNT_BY_ACCOUNT_ID, getAccountByAccountId);
  yield takeEvery(REQUEST_PASSWORD_RESET, requestPasswordReset);
  yield takeEvery(VERIFY_ACCOUNT_TOKEN, verifyUserToken);
  yield takeEvery(RESET_ACCOUNT_PASSWORD, resetAccountPassword);
  yield takeEvery(FETCH_AUTHORIZED_EVENT, fetchAuthorizedEvent);
  yield takeEvery(FETCH_USER_PURCHASES, fetchUserPurchases);
  yield takeEvery(FETCH_ORDER_DETAILS, fetchOrderDetails);
  yield takeEvery(POST_CONSUME_EVENT, postConsumeEvent);
  yield takeEvery(LOGIN_SSO, loginSso);
}

export default user;
